export default function () {
  return {
    searchips: [],
    searchipsCurrentPage: 1,
    searchipsLastPage: 1,
    searchipsPerPage: 0,
    searchipsTotal: 0,
    searchipsLoading: false,
    ckeysLoading: false,
    ipOrdersLoading: false,
    indexPage: null,
    search: '',
    datefrom: '',
    dateto: ''
  }
}
